import getTags from './getTags'
export default getTags
